import { ITablelistAction } from '../interfaces';

export class WorklistAction implements ITablelistAction {
  public static builder(key: string, label: string, action: (self?) => void, enableCondition: (self?) => boolean = () => true) {
    return new WorklistAction(key, label, action, () => true, enableCondition);
  }

  protected constructor(
    public key: string,
    public label: string,
    public action: (self) => void,
    public displayCondition: (self) => boolean = () => true,
    public enableCondition: (self) => boolean = () => true
  ) {
  }
}
